import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { getUsers } from 'src/services/user.service';
import config from 'src/config';
import ContainersList from './../modules/containers/List';
import UsersPage from './Users.page';

class OrganizationManagement extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            role: localStorage.getItem('role') || config.USER_ROLES.USER,
            value: 'users'
        };
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve);
        });
    }

    render() {
        return (
            <>

                <TabContext value={this.state.value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={(e, value) => {
                            this.setState({ value });
                        }} aria-label="lab API tabs example">
                            {(this.state.role != config.USER_ROLES.USER) ? (
                                <Tab label="Users" value="users" />
                            ) : null}
                        </TabList>
                    </Box>
                    <TabPanel value="users">
                        <UsersPage />
                    </TabPanel>
                </TabContext>
            </>
        );
    }
}

// Wrap and export
export default function (props) {
    const navigate = useNavigate();
    const params = useParams();

    return <OrganizationManagement {...props} navigate={navigate} params={params} />;
}
